"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CptCodeQuestion = void 0;
require("antd/lib/select/style");
var _select = _interopRequireDefault(require("antd/lib/select"));
require("antd/lib/table/style");
var _table = _interopRequireDefault(require("antd/lib/table"));
require("antd/lib/icon/style");
var _icon = _interopRequireDefault(require("antd/lib/icon"));
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _utils = require("../../utils");
require("./CptCodeQuestion.less");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var dataColumns = (0, _lodash.times)(4, function (i) {
  var id = i + 1;
  return {
    title: id,
    dataIndex: id,
    key: id
  };
});
var CptCodeQuestion = function CptCodeQuestion(_ref) {
  var required = _ref.required,
    answer = _ref.answer,
    form = _ref.form,
    disabled = _ref.disabled,
    name = _ref.name,
    defaultValue = _ref.defaultValue;
  var fieldName = name || '';
  var htmlId = (0, _utils.useUniqueHtmlId)();
  var _useRequest = (0, _utils.useRequest)((0, _utils.getCptCodesUrl)()),
    _useRequest$data = _useRequest.data,
    cptCodes = _useRequest$data === void 0 ? [] : _useRequest$data;
  var dataSource = (0, _react.useMemo)(function () {
    var currentAnswer = (answer === null || answer === void 0 ? void 0 : answer.text) || defaultValue;
    // Support deprecated answer if it is the current answer
    if (currentAnswer && !cptCodes.some(function (option) {
      return option === currentAnswer;
    })) {
      cptCodes.unshift(currentAnswer);
    }
    return cptCodes.map(function (option) {
      var parts = option.split(_utils.CPT_CODE_SEPARATOR);
      return {
        text: option,
        1: parts[0],
        2: parts[1],
        3: parts[2],
        4: parts[3]
      };
    });
  }, [cptCodes, answer, defaultValue]);
  var control = /*#__PURE__*/_react.default.createElement(_select.default, {
    id: htmlId,
    className: "w-full",
    size: "large",
    disabled: disabled,
    suffixIcon: /*#__PURE__*/_react.default.createElement(_icon.default, {
      className: "icon-arrow"
    }),
    dropdownRender: function dropdownRender() {
      return /*#__PURE__*/_react.default.createElement(_table.default, {
        className: "cpt-code-table",
        columns: dataColumns,
        dataSource: dataSource,
        showHeader: false,
        pagination: false,
        onRow: function onRow(record) {
          return {
            onMouseDown: function onMouseDown() {
              form === null || form === void 0 ? void 0 : form.setFieldsValue(_defineProperty({}, fieldName, record.text));
            }
          };
        }
      });
    }
  }, dataSource.map(function (answer) {
    return /*#__PURE__*/_react.default.createElement(_select.default.Option, {
      key: answer.text,
      value: answer.text,
      disabled: disabled
    }, answer.text.split(_utils.CPT_CODE_SEPARATOR).join(' | '));
  }));
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: htmlId,
    className: "mb-[8px] block"
  }, "CPT Code"), form ? form.getFieldDecorator(fieldName, {
    rules: [{
      required: required,
      message: 'Answer is required'
    }],
    initialValue: defaultValue
  })(control) : control);
};
exports.CptCodeQuestion = CptCodeQuestion;